import {
  Box,
  Button,
  CircularProgress,
  Collapse,
  Grid,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
  useMediaQuery,
} from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import {
  BGColor02,
  bgColor07,
  blackColor,
  blackShade01,
  blackShade05,
  blackShade159,
  blackShade23,
  blueColor04,
  borderTextbox,
  copyBtnColor,
  greenColor02,
  greenColor2,
  greenStatusColor01,
  greyColor060,
  greyColor13,
  greyColor42,
  greyColor9,
  greyShade01,
  lightgreenColor04,
  mobilePrimary,
  orangeColor02,
  orangeStatusColor,
  orderCardBorder,
  outOfStockColor,
  primaryColor,
  purpleColor01,
  redColor01,
  redColor09,
  redStatusColor01,
  tamrindColor01,
  whiteColor,
} from "../../configs/styles/muiThemes";
import PrintOutlinedIcon from "@mui/icons-material/PrintOutlined";
import FileOpenOutlinedIcon from "@mui/icons-material/FileOpenOutlined";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import TextAreaComponent from "../../components/Input/TextAreaComponent";
import { TextBox } from "../../components/Input/TextBox";
import SearchBoxInput from "../../components/Input/SearchBoxInput";
import SearchBoxInputBlur from "../../components/Input/SearchBoxInputBlur";
import PillSearch from "../../components/Input/PillSearch";
import FilterCard from "../newCatalog/FilterCard";
import ReportSearch from "../../components/Input/ReportSearch";
import OrderReportFilterCard from "./OrderReportFilterCard";
import FilterListRoundedIcon from "@mui/icons-material/FilterListRounded";
import {
  clearAllOrderInfo,
  clearDeliveryStatusInfo,
  getAllOrdersData,
  getDelhiveryB2BStatus,
  getDelhiveryStatus,
  getTelyportStatus,
} from "../../reducers/orders/ordersSlice";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import {
  addThousandsSeparator,
  getOrderDeliveryTypeText,
  getOrderType,
  getOrderTypeText,
  getOrderTypeTextShow,
} from "../../utils/helper";
import { getBuyerAppLookupAPI } from "../../service/api_calls/BusinessPreview/BusinessPreviewAPI";
import { stickyHeader, textOneLines, textTwoLines } from "../../utils/styles";
import LightToolTip from "../../components/Alerts/LightToolTip";
import InfiniteScroll from "react-infinite-scroll-component";
import ThreeDotLoader from "../../components/ThreeDotLoader";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import ProductDetailsOrderReport from "./PopupCard/ProductDetailsOrderReport";
import { getCartInfoApi } from "../../service/api_calls/grievance/grievanceApi";
import Inventory2OutlinedIcon from "@mui/icons-material/Inventory2Outlined";
import AccountBalanceWalletOutlinedIcon from "@mui/icons-material/AccountBalanceWalletOutlined";
import OrderReportOrderDetailsCard from "./OrderReportOrderDetailsCard";
import * as XLSX from "xlsx";
import ListEmptyCard from "../../components/ListEmptyCard";
import MobileEmptyCard from "./MobileEmptyCard";
import CancelIcon from "@mui/icons-material/Cancel";
import { getStatsCountInfoData } from "../../reducers/businessDashboard/BusinessDashboardSlice";
import EmptyCard from "../../components/Alerts/EmptyCard";
import ProductionQuantityLimitsOutlinedIcon from "@mui/icons-material/ProductionQuantityLimitsOutlined";
import { useNavigate } from "react-router-dom";
import { getOrderReportByBusinessAndDurationAPI } from "../../service/api_calls/ordersReports/OrderReportsAPi";
import { getBranchInfoAPI } from "../../service/api_calls/multiBranchCatalog/multiBranchCatalogAPIs";
import { getSummaryMultiBranch } from "../../reducers/multiBranchOrderAnalysis/multiBranchOrderSummarySlice";
import {
  clearorderReportsInfoMB,
  getOrderReportsDataMultiBranch,
} from "../../reducers/multiBranchOrderReports/multiBranchOrderReportsSlice";
import MultiBranchInfo from "../MultiBranchOrderSummaryReport/Sections/MultiBranchInfo";
import { getMainBranchInfoApi } from "../../service/api_calls/dashboard/dashboardApi";

function MultiBranchOrderReportsContent() {
  const matches = useMediaQuery((theme) => theme.breakpoints.up("md"));

  const PAGE_SIZE = 100;

  const dispatch = useDispatch();

  const navigate = useNavigate();

  const [activeTab, setActiveTab] = useState("details");

  const { activeBusinessInfo } = useSelector((state) => state.businessPreview);

  const [masterBranchInfo, setMasterBranchInfo] = useState(null);
  const [branchInfo, setBranchInfo] = useState(null);

  const {
    summaryCountMultiBranch,
    summaryCountLoader,
    orderSaleAmtYearDataMultiBranch,
    orderReportByDaysMB,
    orderSaleAmtTableMonthDataMB,
  } = useSelector((state) => state.multiBranchOrderSummary);

  const handleTabChange = (tab) => {
    setActiveTab(tab);
    const businessUrl = sessionStorage.getItem("costboWEBURL");

    if (tab === "details") navigate(`/${businessUrl}/multiBranchOrderReports`);
    else if (tab === "summary")
      navigate(`/${businessUrl}/multiBranchOrderReportsSummary`);
  };

  const [showWebstoreFilter, setShowWebstoreFilter] = useState(false);
  const [hasMoreData, setHasMoreData] = useState(true);

  const [toggleBtn, settoggleBtn] = useState(false);
  const [toggledIndex, setToggledIndex] = useState(null);

  const webstoreFilterRef = useRef(null);

  const [searchValues, setSearchValues] = useState({
    orderId: "",
    ondcOrderId: "",
    orderType: "",
    buyerApp: "",
    status: "",
    deliveryType: "",
    from: null,
    to: null,
    deliveredFrom: null,
    deliveredTo: null,
    errors: null,
  });

  const [deliveryType, setDeliveryType] = useState("");
  const [cartInfo, setCartInfo] = useState(null);
  const [orderData, setorderData] = useState(null);
  const [filterCount, setfilterCount] = useState([]);

  const { orderdata, orderReportsDataPageNo, orderReportsDataLoader } =
    useSelector((state) => state.multiBranchOrderReports);

  const [openRow, setOpenRow] = useState(null);

  const [excelLoading, setExcelLoading] = useState(false);
  const [excelErr, setExcelErr] = useState("");

  const toggleRow = (orderId) => {
    setOpenRow((prev) => (prev === orderId ? null : orderId));
  };

  const getOrdersData = (params, isNextPage) => {
    const businessId = sessionStorage.getItem("selectedBusinessId");
    console.log("isNextPage", isNextPage);
    console.log("params123", params);

    let mainBranchId = businessId;
    if (!activeBusinessInfo?.mainBranch && activeBusinessInfo?.mainBranchId) {
      mainBranchId = activeBusinessInfo?.mainBranchId || "";
    }

    const branchIds = branchInfo?.branchInfo
      ?.map((item) => item?.branchId)
      ?.join(",");

    dispatch(
      getOrderReportsDataMultiBranch({
        businessIds: branchIds + `,${mainBranchId}`,
        pageSize: PAGE_SIZE,
        pageNo: isNextPage === true ? orderReportsDataPageNo : 1, // Increment `pageNo` in the request
        ...params,
      })
    );
  };

  const [bapNameList, setBapNameList] = useState(null);

  const getBapDisplayNameInfo = async () => {
    const response = await getBuyerAppLookupAPI();

    if (response?.details?.length > 0) {
      setBapNameList(response?.details || []);
    }
  };
  // Get ONDC Bap Display Name by Subscriber ID
  const getOndcBapNameBySubscriberId = (id) => {
    const data = bapNameList?.find((item) => item?.subscriberId === id);
    return data ? data?.displayName : "";
  };

  const searchOndcBapNameBySubscriberId = (id) => {
    const data = bapNameList?.find((item) => item?.displayName === id);
    return data ? data?.subscriberId : "";
  };

  const onSearchStart = () => {
    dispatch(clearorderReportsInfoMB());
  };

  // const fetchNextData = () => {
  //   console.log("fetchNextData", orderData);

  //   getOrdersData();
  // };
  const fetchNextData = () => {
    console.log("Fetching next page:", orderReportsDataPageNo + 1);

    getOrdersData(orderData || "", true); // Pass `true` to indicate fetching next page
  };

  const fetchCartInfo = async (orderData) => {
    const businessId = sessionStorage.getItem("selectedBusinessId");

    const response = await getCartInfoApi({
      cartId: orderData?.cartId,
      businessId,
    });

    if (response?.cart) {
      setCartInfo(response?.cart || null);
    }
  };

  const getSearchFilterData = () => {
    const searchFilters = filterCount
      ?.map(
        (item, index) =>
          `${
            item?.field
              ? item.field.charAt(0).toUpperCase() + item.field.slice(1)
              : ""
          } : ${
            item?.field === "Status"
              ? getOrderTypeText(item?.value)
              : item?.field === "Buyer App"
              ? getOndcBapNameBySubscriberId(item.value)
              : item?.field === "Order Type"
              ? item?.value === true
                ? "ONDC Order"
                : "Website Order"
              : item?.field === "Delivery Type"
              ? getOrderDeliveryTypeText(item?.value)
              : item?.value
          }${index !== filterCount?.length - 1 ? "," : "."} `
      )
      ?.join("");

    console.log("DOWNLOAD_EXCEL____searchFilters", searchFilters);

    return `Search By - ${searchFilters}`;
  };

  const validateDateRange = (filters) => {
    const getValue = (field, defaultValue) => {
      const entry = filters.find((item) => item.field === field);
      return entry ? new Date(entry.value) : defaultValue;
    };

    const defaultFromDate = new Date("2022-01-01"); // Default: Jan 1, 2022
    const defaultToDate = new Date(); // Default: Current date

    const from = getValue("from", defaultFromDate);
    const to = getValue("to", defaultToDate);
    const deliveredFrom = getValue("deliveredFrom", defaultFromDate);
    const deliveredTo = getValue("deliveredTo", defaultToDate);

    const maxDays = 15;

    if ((to - from) / (1000 * 60 * 60 * 24) > maxDays) {
      return "Reports can be generated for 15 or fewer days.";
    }

    if ((deliveredTo - deliveredFrom) / (1000 * 60 * 60 * 24) > maxDays) {
      return "Reports can be generated for 15 or fewer days.";
    }

    return null; // No error
  };

  const exportToExcel = async (data) => {
    if (filterCount?.length == 0) {
      setExcelErr("Select the date range to generate the report");
      return;
    }

    if (!data || data.length === 0) {
      console.error("No data provided for export.");
      return;
    }

    // const errorMessage = validateDateRange(filterCount);
    // if (errorMessage) {
    //   console.error(errorMessage);
    //   setExcelErr(errorMessage);
    //   return;
    // }

    // setExcelErr("");
    setExcelLoading(true);

    // const businessId = sessionStorage.getItem("selectedBusinessId");
    // const excelData = await getOrderReportByBusinessAndDurationAPI([`${businessId}`])

    const fileName = `Order_Detail_Analysis_${moment().format("Do_MM_YYYY")}`;
    const businessName = activeBusinessInfo?.name || "";

    const searchFilterInfo = getSearchFilterData();

    // Define headers
    const headers = [
      [`Order Details Analysis`],
      [`${businessName}`, `Report Date - ${moment().format("Do MMM YYYY")}`],
      [
        `${searchFilterInfo}`,
        `Total Orders - ${orderdata?.count || 0}`,
        `Total Sales - ₹ ${orderdata?.totalOrderSales}`,
      ],
      [
        "S.no",
        "Order Id",
        "Order Type",
        "ONDC Order Id",
        "Order Date",
        "Customer Info",
        "Contact No",
        "City",
        "State",
        "Zip",
        "Address",
        "Delivery Type",
        "Status",
        "Delivery Date",
        "Total Qty",
        "Order Product Total",
        "Shipping Cost",
        "Discount",
        "Order Total Cost",
        "Product Name",
        "Product Measurement Weight",
        "Current Quantity",
        "Product Original Price",
        "Product Sale Price",
        "Tax Rate",
        "Product Tax",
        "Product Discount",
        "Product Total Price Before Discount",
      ],
    ];

    try {
      const businessId = sessionStorage.getItem("selectedBusinessId");

      // Fetch product details for each order in parallel
      const ordersWithProducts = await Promise.all(
        data.map(async (item, index) => {
          // Fetch cart info
          const response = await getCartInfoApi({
            cartId: item?.cartId,
            businessId,
          });

          const cartData = response?.cart || null;
          const productList = response?.cart?.productList || [];

          const orderDetails = [
            index + 1,
            item?.orderId || "",
            getOrderType(item)?.label || "",
            item?.ondcOrderId || "",
            item?.orderCreatedOn
              ? moment(item?.orderCreatedOn)?.format(
                  "ddd MMM DD HH:mm:ss [GMT] YYYY"
                )
              : "",
            item?.customerAddressName || "",
            item?.profilePhone || "",
            `${cartData?.customerAddress?.city}`,
            `${cartData?.customerAddress?.state}`,
            `${cartData?.customerAddress?.zip}`,
            `${cartData?.customerAddress?.addressLine1}, ${cartData?.customerAddress?.city}, ${cartData?.customerAddress?.state} - ${cartData?.customerAddress?.zip}`,
            getOrderDeliveryTypeText(
              item?.deliveryType?.type,
              item?.deliveryType?.shipType || ""
            ),
            getOrderTypeText(item?.orderStatus) || "",
            item?.orderDeliveredOn
              ? moment(item?.orderDeliveredOn)?.format(
                  "ddd MMM DD HH:mm:ss [GMT] YYYY"
                )
              : "-",
            item?.totalQuantity || "",
            item?.orderTotalProductCost || "",
            item?.shippingCost || "",
            item?.discountDetails?.[0]?.discountAmount > 0
              ? item?.discountDetails?.[0]?.discountAmount
              : "",
            item?.orderTotalCost || "",
          ];

          if (productList.length === 0) {
            return [[...orderDetails, "", "", ""]];
          }

          return productList.map((product, productIndex) => {
            const qty = Number(item?.totalQuantity);
            const pSalePrice = Number(product?.productSalePrice || 0);

            const pTotal = qty * pSalePrice;
            const taxRate = Number(product?.productTaxRate || 0);

            // producttotal-((producttotal*100)/(100+taxrate))
            // 220 - ((220*100)/(100+5))
            //220 - ((22000)/105)
            // 220 - 209.52381

            const productTax = pTotal - (pTotal * 100) / (100 + taxRate);

            return [
              ...(productIndex === 0
                ? orderDetails
                : new Array(orderDetails.length).fill("")),
              product?.productName || "",
              product?.measurementInfo?.weight || "",
              product?.currentQuantity || "",
              product?.productOriginalPrice || "",
              product?.productSalePrice || "",
              product?.productTaxRate || "",
              productTax?.toFixed(3),
              product?.discountSum || "",
              product?.productTotalBeforeDiscount || "",
            ];
          });
        })
      );

      // Flatten the array
      const formattedData = ordersWithProducts.flat();

      console.log("DOWNLOAD_EXCEL____formattedData", { formattedData, data });

      // Combine headers and data
      const finalData = [...headers, ...formattedData];

      // Convert to worksheet
      const worksheet = XLSX.utils.aoa_to_sheet(finalData);

      // Create workbook and append worksheet
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Orders");

      // Write workbook and create Blob
      const excelBuffer = XLSX.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });
      const excelBlob = new Blob([excelBuffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      // Create download link
      const url = URL.createObjectURL(excelBlob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `${fileName}.xlsx`;
      document.body.appendChild(a);

      setTimeout(() => {
        a.click();

        // Cleanup
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
        setExcelLoading(false);
      }, 2000);
    } catch (error) {
      console.error("Error exporting data:", error);
      setExcelLoading(false);
    }
  };

  const clearAllFilterData = () => {
    setExcelErr("");
    setSearchValues({
      orderId: "",
      ondcOrderId: "",
      orderType: "",
      buyerApp: "",
      status: "",
      deliveryType: "",
      from: "",
      to: "",
      deliveredFrom: "",
      deliveredTo: "",
    });
  };

  const hasCriteria = Object.values(searchValues).some(
    (value) => value && value !== ""
  );
  const getBranchDetails = async () => {
    const businessId = sessionStorage.getItem("selectedBusinessId");

    let mainBranchId = businessId;
    let masterBranchData = activeBusinessInfo;

    if (!activeBusinessInfo?.mainBranch && activeBusinessInfo?.mainBranchId) {
      mainBranchId = activeBusinessInfo?.mainBranchId || "";
      masterBranchData = await getMainBranchInfoApi(businessId);
    }

    setMasterBranchInfo(masterBranchData?.details || activeBusinessInfo);

    console.log("branchListData____hit", mainBranchId);
    const branchListData = await getBranchInfoAPI(mainBranchId);
    console.log("branchListData____", branchListData);
    setBranchInfo(branchListData?.details || null);

    const branchIds = branchListData?.details?.branchInfo
      ?.map((item) => item?.branchId)
      ?.join(",");
    console.log("branchListData____branchIds", branchIds);

    dispatch(
      getSummaryMultiBranch({
        branchIds: branchIds + `,${mainBranchId}`,
        businessId,
      })
    );
  };

  // useEffect(() => {
  //   fetchCartInfo(orderData);

  //   return () => {
  //     dispatch(clearDeliveryStatusInfo());
  //   };
  // }, [orderData]);

  useEffect(() => {
    if (cartInfo) {
      console.log("cartInfo", cartInfo);
      const orderDeliveryType =
        cartInfo?.deliveryType?.type?.toLowerCase() || "";

      if (
        orderDeliveryType == "delhivery"
        // || orderDeliveryType == "delhiveryb2b"
      ) {
        if (cartInfo?.shipmentInfo?.carrierTrackId) {
          dispatch(getDelhiveryStatus(cartInfo?.shipmentInfo?.carrierTrackId));
        }
      }

      if (orderDeliveryType == "delhiveryb2b") {
        if (cartInfo?.shipmentInfo?.carrierTrackId) {
          dispatch(
            getDelhiveryB2BStatus(cartInfo?.shipmentInfo?.carrierTrackId)
          );
        }
      }

      if (orderDeliveryType.toLowerCase() == "telyport") {
        if (cartInfo?.shipmentInfo?.carrierTrackId) {
          dispatch(getTelyportStatus(cartInfo?.shipmentInfo?.carrierTrackId));
        }
      }

      setDeliveryType(cartInfo?.deliveryType?.type || "");
    }
  }, [cartInfo]);

  useEffect(() => {
    getBranchDetails();
    getBapDisplayNameInfo();
  }, []);

  useEffect(() => {
    const businessId = sessionStorage.getItem("selectedBusinessId");
    if (summaryCountMultiBranch?.totalOrders > 0 && branchInfo) {
      console.log("GET___REPORTS____", { summaryCountMultiBranch, branchInfo });

      getOrdersData();
    }
    return () => {
      dispatch(clearorderReportsInfoMB());
    };
  }, [summaryCountMultiBranch]);

  useEffect(() => {
    console.log(
      "Checking hasMoreData condition:",
      orderReportsDataPageNo,
      orderdata?.details?.length
    );

    if ((orderReportsDataPageNo - 1) * PAGE_SIZE > orderdata?.details?.length) {
      setHasMoreData(false);
    } else {
      setHasMoreData(true);
    }
  }, [orderReportsDataPageNo]);

  return (
    <Box
      sx={{
        background: whiteColor,
        //  marginBottom: "24px",
        borderRadius: "10px",
        padding: { xs: "20px 15px", md: "15px" },
        mt: "20px",
        // textAlign: "center",
        border: "1px solid #e5e9f0",
        boxShadow: "0 3px 4px rgb(229 233 240 / 22%)",
        // marginTop: "15px",
        // minHeight: { xs: "calc(100vh - 91px)", md: "100vh" },
      }}
    >
      <Box
        sx={{
          ...stickyHeader,
          pb: { md: 1, xs: 0 },
          pt: 0,
          display: { md: "block", xs: "none" },
          backgroundColor: whiteColor,
        }}
      >
        <Box
          sx={{
            display: "flex",
            background: whiteColor,
            justifyContent: "space-between",
            mb: "10px",
          }}
        >
          <Box display={"flex"} flexDirection={"column"}>
            <Box
              sx={{
                // height: "55px",
                display: "flex",
                borderBottom: "0px solid #e7e8eb",
                borderRadius: "7px",
                background: "#f1f4f7",
                padding: "8px 12px",
                gap: 2,
              }}
            >
              <Button
                onClick={() => handleTabChange("summary")}
                sx={{
                  height: "35px",
                  color: blackColor,
                  // color: activeTab === "summary" ? "#ffffff" : "#3f53d8",
                  // border: "1px solid #3f53d8",
                  background:
                    activeTab === "summary" ? "#3f53d8" : "transparent",
                  borderRadius: "5px",
                  fontSize: "13px",
                  fontWeight: 600,
                  px: "15px",
                  textTransform: "capitalize",
                  "&:hover": {
                    backgroundColor: "#3f53d8",
                    color: "#ffffff",
                  },
                }}
              >
                Multi Branch Order Summary
              </Button>

              <Button
                onClick={() => handleTabChange("details")}
                sx={{
                  height: "35px",
                  px: "15px",
                  color: activeTab === "details" ? "#ffffff" : "#3f53d8",
                  border: "1px solid #3f53d8",
                  background:
                    activeTab === "details" ? "#3f53d8" : "transparent",
                  borderRadius: "5px",
                  fontSize: "13px",
                  fontWeight: 600,
                  textTransform: "capitalize",
                  "&:hover": {
                    backgroundColor: "#3f53d8",
                    color: "#ffffff",
                  },
                }}
              >
                Multi Branch Order Detail Analysis
              </Button>
            </Box>
          </Box>
          {summaryCountMultiBranch?.totalOrders > 0 && (
            <Box display={"flex"} gap={2}>
              <TotalOrderDetail
                label={"Total Orders"}
                value={summaryCountMultiBranch?.totalOrders || 0}
                borderColor={`1px solid #ffdfed`}
                bgColor={"#fff3f9"}
                icon={
                  <Inventory2OutlinedIcon sx={{ fontSize: "26px", pr: 1 }} />
                }
                iconColor={"#c94b85"}
              />

              <TotalOrderDetail
                label={"Total Sales"}
                value={`₹ ${addThousandsSeparator(
                  summaryCountMultiBranch?.totalAmount
                )}`}
                borderColor={`1px solid #d3f8de`}
                bgColor={"#f1fff5"}
                icon={
                  <AccountBalanceWalletOutlinedIcon
                    sx={{ fontSize: "26px", pr: 1 }}
                  />
                }
                iconColor={"#13ccac"}
              />
            </Box>
          )}
        </Box>

        <Box mb={3} mt={0}>
          <MultiBranchInfo
            masterBranchInfo={masterBranchInfo}
            branchInfo={branchInfo?.branchInfo}
          />
        </Box>

        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
          <Typography
            variant="h5"
            color={blackShade05}
            fontSize={{ xs: "14.5px", md: "15px" }}
            fontWeight="600"
          >
            Order Detail Analysis
          </Typography>
          {summaryCountMultiBranch?.totalOrders > 0 && (
            <Box display={"flex"} gap={3} mt={-1}>
              <Box
                display={"flex"}
                gap={2}
                position={{ xs: "relative", md: "static" }}
                //   mt={{ xs: 0, md: 2 }}
              >
                <Box
                  position={{ md: "relative", xs: "static" }}
                  ref={webstoreFilterRef}
                >
                  <Button
                    sx={{ ...styles.filterIconBtn, width: "150px" }}
                    variant="contained"
                    disableElevation
                    onClick={() => {
                      setShowWebstoreFilter((prev) => !prev);
                    }}
                    endIcon={
                      <FilterListRoundedIcon sx={{ fontSize: "17px" }} />
                    }
                  >
                    {matches ? "SEARCH FILTER" : "SEARCH FILTER"}
                  </Button>
                  {showWebstoreFilter && (
                    <OrderReportFilterCard
                      title="Search Filter"
                      setSearchValues={setSearchValues}
                      searchValues={searchValues}
                      onCancel={() => {
                        setShowWebstoreFilter((prev) => !prev);
                      }}
                      onAllClear={clearAllFilterData}
                      setorderData={(params) => {
                        console.log("params", params);

                        setExcelErr("");
                        setorderData(params);
                        onSearchStart();
                        getOrdersData(params, false);
                      }}
                      setfilterCount={setfilterCount}
                      bapNameList={bapNameList}
                      searchOndcBapNameBySubscriberId={
                        searchOndcBapNameBySubscriberId
                      }
                      filterCount={filterCount}
                    />
                  )}
                </Box>
              </Box>
              <Box>
                <LightToolTip
                  title={"Excel Download Coming soon"}
                  placement="right"
                >
                  <IconButton
                    sx={styles.backBtn}
                    variant="contained"
                    disableElevation
                    onClick={() => exportToExcel(orderdata?.details || [])}
                    disabled={excelLoading}
                    // startIcon={}
                  >
                    {excelLoading ? (
                      <CircularProgress size={16} color="inherit" />
                    ) : (
                      <Box
                        component="img"
                        maxHeight={{ xs: "29px", md: "40px" }}
                        src={`/./assets/image/pdf-icon-04.svg`}
                        alt="CostBo"
                      />
                    )}

                    {excelLoading && (
                      <Typography
                        fontSize={11}
                        fontWeight={500}
                        color={blackColor}
                        sx={{ textDecoration: "none", ml: 1 }}
                      >
                        Preparing Data...
                      </Typography>
                    )}
                  </IconButton>
                </LightToolTip>
              </Box>
            </Box>
          )}
        </Box>

        <Box display="flex" alignItems="center" justifyContent="flex-end">
          {excelErr && (
            <Typography fontSize={11} fontWeight={500} color={redColor01}>
              {excelErr}
            </Typography>
          )}
        </Box>

        {hasCriteria && filterCount.length > 0 && (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "15px",
              marginBottom: "15px",
              marginTop: "10px",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: "15px",
                // marginBottom: "15px",
                // marginTop: "10px",
              }}
            >
              <Box
                sx={{
                  width: filterCount?.length > 4 ? "850px" : "auto",
                  display: "flex",
                  background: "#ebf0f5",
                  borderRadius: "7px",
                  alignItems: "center",
                  gap: "8px",
                  padding: "2px 15px 2px 8px",
                  border: "1px solid #E1E8F0",
                  position: "relative",
                  // height: "29px",
                }}
              >
                <Box
                  sx={{
                    color: "#8593AC",
                    fontWeight: 400,
                    fontSize: "17px",
                    position: "absolute",
                    top: "-12px",
                    right: "-3px",
                  }}
                  onClick={() => {
                    clearAllFilterData();
                    setfilterCount([]);
                    onSearchStart();
                    setorderData([]);
                    getOrdersData(1);
                  }}
                >
                  <CancelIcon />
                </Box>
                <Box
                  display="flex"
                  alignItems="center"
                  gap={1}
                  flexWrap={filterCount?.length > 4 ? "wrap" : "nowrap"}
                >
                  <Typography
                    sx={{
                      // width: "90%",
                      fontSize: "12px",
                      fontWeight: 400,
                      color: "#0e1f42",
                      lineHeight: "18px",
                      display: "inline",
                      whiteSpace: filterCount?.length > 4 ? "normal" : "nowrap",
                      wordBreak: "break-word",
                    }}
                  >
                    Search by -{" "}
                    {filterCount?.map((item, index) => (
                      // <Box
                      //   key={index}
                      //   component="span"
                      //   flexWrap="nowrap"
                      //   sx={{
                      //     whiteSpace: "normal",
                      //     wordBreak: "break-word",
                      //   }}
                      // >
                      //   {item?.field === "from"
                      //     ? "OrderFrom"
                      //     : item?.field === "to"
                      //     ? "OrderTo"
                      //     : item?.field}{" "}
                      //   :{" "}
                      //   <strong>
                      //     {/* {String(
                      //     item?.field === "Status"
                      //       ? getOrderTypeText(item?.value)
                      //       : item?.field === "Buyer App"
                      //       ? getOndcBapNameBySubscriberId(item.value)
                      //       : item?.field === "Order Type"
                      //       ? item?.value === true
                      //         ? "ONDC Order"
                      //         : "Website Order"
                      //       : item?.field === "Delivery Type"
                      //       ? getOrderDeliveryTypeText(item?.value)
                      //       : item?.value
                      //   )
                      //     .split(",") // Splits text into an array at each comma
                      //     .map((text, i, arr) => (
                      //       <Box key={i} component="span" display="block">
                      //         {text}
                      //         {i !== arr.length - 1 && ","}{" "}
                      //       </Box>
                      //     ))} */}
                      //     {item?.field === "Status"
                      //       ? getOrderTypeText(item?.value)
                      //       : item?.field === "Buyer App"
                      //       ? getOndcBapNameBySubscriberId(item.value)
                      //       : item?.field === "Order Type"
                      //       ? item?.value === true
                      //         ? "ONDC Order"
                      //         : "Website Order"
                      //       : item?.field === "Delivery Type"
                      //       ? getOrderDeliveryTypeText(item?.value)
                      //       : item?.value}
                      //     {index !== filterCount?.length - 1 ? "," : "."}{" "}
                      //   </strong>
                      // </Box>
                      <Box
                        key={index}
                        component="span"
                        flexWrap="nowrap"
                        sx={{
                          whiteSpace: "normal",
                          wordBreak: "break-word",
                        }}
                      >
                        {item?.field
                          ? item.field.charAt(0).toUpperCase() +
                            item.field.slice(1)
                          : ""}{" "}
                        :{" "}
                        <strong>
                          {item?.field === "Status"
                            ? getOrderTypeText(item?.value)
                            : item?.field === "Buyer App"
                            ? getOndcBapNameBySubscriberId(item.value)
                            : item?.field === "Order Type"
                            ? item?.value === true
                              ? "ONDC Order"
                              : "Website Order"
                            : item?.field === "Delivery Type"
                            ? getOrderDeliveryTypeText(item?.value)
                            : item?.value}
                          {index !== filterCount?.length - 1 ? "," : "."}{" "}
                        </strong>
                      </Box>
                    ))}
                  </Typography>
                  {/* <Typography
                          sx={{
                            fontSize: "12px",
                            fontWeight: 600,
                            color: "#0e1f42",
                            lineHeight: "26px",
                            whiteSpace: "nowrap",
                          }}
                        >
                          No. of Orders : {orderdata?.count}, Total Sales : ₹{" "}
                          {addThousandsSeparator(orderdata?.totalOrderSales)}
                        </Typography> */}
                </Box>
              </Box>
            </Box>
            <Box display={"flex"} gap={2}>
              <SearchOrderDetail
                label={"Total Orders"}
                value={orderdata?.count || 0}
                borderColor={`1px solid #ffdfed`}
                bgColor={"#fff3f9"}
                iconColor={"#c94b85"}
                displaytype={filterCount?.length > 4 ? "column" : "row"}
              />

              <SearchOrderDetail
                label={"Total Sales"}
                value={`₹ ${addThousandsSeparator(orderdata?.totalOrderSales)}`}
                borderColor={`1px solid #d3f8de`}
                bgColor={"#f1fff5"}
                iconColor={"#13ccac"}
                displaytype={filterCount?.length > 4 ? "column" : "row"}
              />
            </Box>
          </Box>
        )}
        {summaryCountMultiBranch?.totalOrders > 0 && (
          <Box sx={styles.card} mt={2}>
            <Grid container spacing={2}>
              <Grid item xs={6} md={1.5}>
                <Typography
                  variant="h5"
                  fontSize={12}
                  fontWeight={400}
                  color={greyColor060}
                >
                  Order Id
                </Typography>
              </Grid>
              <Grid item xs={6} md={3}>
                <Typography
                  variant="h5"
                  fontSize={12}
                  fontWeight={400}
                  color={greyColor060}
                >
                  Order Type
                </Typography>
              </Grid>{" "}
              <Grid item xs={6} md={1.2}>
                <Typography
                  variant="h5"
                  fontSize={12}
                  fontWeight={400}
                  color={greyColor060}
                >
                  Date
                </Typography>
              </Grid>
              <Grid item xs={6} md={1.8}>
                <Typography
                  variant="h5"
                  fontSize={12}
                  fontWeight={400}
                  color={greyColor060}
                >
                  Customer Info
                </Typography>
              </Grid>
              <Grid item xs={12} md={1}>
                <Typography
                  variant="h5"
                  fontSize={12}
                  fontWeight={400}
                  color={greyColor060}
                >
                  Total Cost
                </Typography>
              </Grid>
              <Grid item xs={12} md={1.75}>
                <Typography
                  variant="h5"
                  fontSize={12}
                  fontWeight={400}
                  color={greyColor060}
                >
                  Delivery Type
                </Typography>
              </Grid>
              <Grid item xs={12} md={1.5}>
                <Typography
                  variant="h5"
                  fontSize={12}
                  fontWeight={400}
                  color={greyColor060}
                >
                  Status
                </Typography>
              </Grid>
            </Grid>
          </Box>
        )}
      </Box>

      {orderReportsDataLoader && orderdata?.details?.length == 0 && (
        <ThreeDotLoader />
      )}

      <Box
        id="scrollableDiv"
        height={
          summaryCountMultiBranch?.totalOrders === 0
            ? "30vh"
            : filterCount.length > 0
            ? orderdata?.details?.length > 0
              ? "47vh"
              : "30vh"
            : "53vh"
        }
        sx={{
          overflowY: "scroll",
          scrollbarWidth: "thin",
          "&::-webkit-scrollbar": {
            width: "6px",
          },
          "&::-webkit-scrollbar-thumb": {
            backgroundColor: "#e5e9f0",
            borderRadius: "4px",
          },
          "&::-webkit-scrollbar-track": {
            backgroundColor: "transparent",
          },
        }}
      >
        {summaryCountMultiBranch?.totalOrders > 0 &&
        orderdata?.details?.length > 0 ? (
          <InfiniteScroll
            dataLength={orderdata?.details?.length || 0}
            next={fetchNextData}
            hasMore={hasMoreData}
            loader={
              <Box>
                <ThreeDotLoader />
              </Box>
            }
            scrollableTarget="scrollableDiv" // Add this
          >
            {orderdata?.details?.map((item, index) => (
              <OrderReportOrderDetailsCard
                key={index} // Add key here
                item={item}
                index={index}
                getOndcBapNameBySubscriberId={getOndcBapNameBySubscriberId}
                toggleRow={toggleRow}
                setToggledIndex={setToggledIndex}
                toggledIndex={toggledIndex}
                openRow={openRow}
                toggleBtn={toggleBtn}
              />
            ))}
          </InfiniteScroll>
        ) : null}

        {summaryCountMultiBranch?.totalOrders > 0 &&
          orderdata?.details?.length === 0 &&
          !orderReportsDataLoader && (
            <EmptyCard
              icon={"/./assets/image/order-search-cart-empty-1.svg"}
              iconWidth={"98px"}
              iconHeight={"85px"}
              message={"No orders matching the filter criteria."}
              hideBtn
              margin
              paddingY={"30px"}
            />
          )}

        {summaryCountMultiBranch?.totalOrders === 0 && (
          <EmptyCard
            icon={"/./assets/image/order-cart-empty-1.svg"}
            iconWidth={"98px"}
            iconHeight={"85px"}
            message={"You are yet to receive your first order."}
            hideBtn
            margin
            paddingY={"30px"}
          />
        )}
      </Box>
    </Box>
  );
}

export default MultiBranchOrderReportsContent;

const styles = {
  card: {
    display: { md: "flex", xs: "none" },
    flexDirection: { xs: "column", md: "row" },
    gap: { xs: "16px", md: "20px" },
    backgroundColor: whiteColor,
    // backgroundColor: greyColor42,
    border: orderCardBorder,
    borderRadius: "7px 7px 0px 0px",
    boxShadow: "0 2px 4px rgb(179 188 198 / 5%)",
    padding: "7px 15px",
    position: "sticky",
    top: 248,
    zIndex: 10000,
    // marginBottom: "15px",
  },
  backBtn: {
    // width: "40px",
    width: "auto",
    height: "35px",
    backgroundColor: "#f1f4f7",
    padding: { md: "10px !important", xs: "3px 6px !important" },
    fontSize: "14px",
    color: { xs: mobilePrimary, md: blackShade159 },
    textTransform: "unset",
    border: {
      xs: "1px solid " + "#E4E7F4",
      md: "1px solid " + "#E4E7F4",
    },
    borderRadius: "10px",
    "&:hover": {
      backgroundColor: "transparent",
      color: { xs: mobilePrimary, md: greyColor13 },
    },
  },
  toggleBtn: {
    width: "32px",
    height: "32px",
    backgroundColor: whiteColor,
    padding: { md: "6px !important", xs: "3px 6px !important" },
    fontSize: "11px",
    color: { xs: mobilePrimary, md: greyColor060 },
    textTransform: "unset",
    textDecoration: "underline",
    border: {
      xs: "1px solid " + "#E4E7F4",
      md: "1px solid " + "#E4E7F4",
    },
    borderRadius: "50%",
    "&:hover": {
      backgroundColor: "transparent",
      color: { xs: mobilePrimary, md: greyColor060 },
    },
  },
  filterIconBtn: {
    height: "35px",
    padding: "4px 12px",
    fontSize: "11px",
    fontWeight: 600,
    color: "#3f454f",
    backgroundColor: whiteColor,
    border: "1px solid " + "#d4dae0",
    "&:hover": {
      color: whiteColor,
      backgroundColor: greyColor9,
    },
  },
  tableBodyCell: (color) => ({
    fontSize: 13,
    fontWeight: 500,
    whiteSpace: "nowrap",
    color: color || blackShade01,
    padding: "10px 16px !important",
  }),
};

function TotalOrderDetail({
  label,
  value,
  hideLabel,
  borderColor,
  bgColor,
  icon,
  iconColor,
}) {
  return (
    <Box
      sx={{
        background: bgColor,
        border: borderColor,
        width: "230px",
        height: "55px",
        display: "flex",
        // justifyContent: "space-between",
        marginBottom: "10px",
        alignItems: "center",
        marginTop: "1px",
        padding: "8px 10px",
        borderRadius: "10px",
      }}
    >
      <Box
        sx={{
          width: "35px",
          height: "35px",
          position: "relative",
          top: "0px",
          left: "-10",
          color: "#ffffff",
          background: iconColor,
          border: "1px solid #fff",
          borderRadius: "8px",
          lineHeight: "27px",
          marginRight: "12px",
          padding: "3px 8px",
          textAlign: "center",
        }}
      >
        {icon}
      </Box>
      <Box>
        {!hideLabel ? (
          <Typography
            variant="h3"
            fontSize={{ xs: 12, md: 12 }}
            color={greyColor060}
            fontWeight={400}
            lineHeight={1.5}
            mt={1}
            // sx={{ ...styles }}
          >
            {label}{" "}
          </Typography>
        ) : (
          <Box sx={{ height: "22px" }} />
        )}

        <Typography
          variant="body1"
          fontSize={{ xs: 12.5, md: 14 }}
          color={blackColor}
          fontWeight={600}
          minHeight={{ md: "28px", xs: "24px" }}
        >
          {value}
        </Typography>
      </Box>
      {/* <Box
        component="img"
        maxHeight={{ xs: "29px", md: "40px" }}
        src={}
        alt="CostBo"
      /> */}
    </Box>
  );
}

function SearchOrderDetail({
  label,
  value,
  hideLabel,
  borderColor,
  bgColor,
  displaytype,
  iconColor,
}) {
  return (
    <Box
      sx={{
        background: bgColor,
        border: borderColor,
        // width: "230px",
        // height: "30px",
        display: "flex",
        // justifyContent: "space-between",
        // marginBottom: "10px",
        alignItems: displaytype ? "start" : "center",
        // marginTop: "1px",
        padding: "2px 10px",
        borderRadius: "6px",
        flexDirection: displaytype,
      }}
    >
      {/* <Box
        sx={{
          width: "35px",
          height: "35px",
          position: "relative",
          top: "0px",
          left: "-10",
          color: "#ffffff",
          background: iconColor,
          border: "1px solid #fff",
          borderRadius: "8px",
          lineHeight: "27px",
          marginRight: "12px",
          padding: "3px 8px",
          textAlign: "center",
        }}
      >
        {icon}
      </Box> */}
      {/* <Box display={"flex"} gap={2} alignItems={"center"}> */}
      {!hideLabel ? (
        <Typography
          variant="h3"
          fontSize={{ xs: 12, md: 12 }}
          color={iconColor}
          fontWeight={400}
          lineHeight={1.5}
          // sx={{ ...styles }}
        >
          {label} :
        </Typography>
      ) : (
        <Box sx={{ height: "22px" }} />
      )}

      <Typography
        variant="body1"
        fontSize={{ xs: 12.5, md: 12 }}
        color={iconColor}
        fontWeight={600}
        ml={displaytype === "column" ? 0 : 0.5}
        lineHeight={1.5}
      >
        {value}
      </Typography>
      {/* </Box> */}
      {/* <Box
        component="img"
        maxHeight={{ xs: "29px", md: "40px" }}
        src={}
        alt="CostBo"
      /> */}
    </Box>
  );
}

const inputBox = (hideBorder) => ({
  pb: { md: 0, xs: 0 },
  //   borderBottom: hideBorder ? "none" : border27,
  backgroundColor: bgColor07,
});

const readBtn = {
  fontSize: 12,
  fontWeight: 500,
  color: primaryColor,
  textTransform: "unset",
  textDecoration: "underline",
  padding: "0px",
  ml: 0.5,
};
